import styled, { keyframes } from "styled-components";
import { device } from "./Device";

const QuotesContainer = styled.div`
  width: 100%;
  visibility: ${(props) => props.visibility};
  overflow: hidden; /* masque tout ce qui dépasse */
  @media ${device.tablet} {
    height: 155px;
  }
`;
const translateRight = keyframes`
  0% {
    transform: translate3d(-100%,0,0); /* position initiale à droite */
  }
  100% {
    transform: translate3d(0,0,0);  /* position finale à gauche */
  }
`;
const translateLeft = keyframes`
  0% {
    transform: translate3d(0,0,0);      /* position initiale à droite */
  }
  100% {
    transform: translate3d(-100%,0,0);  /* position finale à gauche */
  }
`;
const QuotesMarquee = styled.p`
  display: inline-block;                /* modèle de boîte en ligne */
  padding-right: 2em;                   /* un peu d'espace pour la transition */
  padding-left: 100%;                   /* placement à droite du conteneur */
  white-space: nowrap;                  /* pas de passage à la ligne */
  animation: ${(props) =>
    props.directionOfAnimation === "translateLeft"
      ? translateLeft
      : translateRight} 90s infinite linear;
  }
  font-family: "Allerta Stencil", arial;
  letter-spacing: -5.8px;
  line-height: 11rem;
  color: #303030;
  opacity: 0.9;
  &:hover {
    animation-play-state: paused; /* met en pause le défilement */
  }

  @media ${device.tablet} {
   letter-spacing: -1px;
  }
}
`;
export { QuotesContainer, QuotesMarquee };
